import { useContext, useEffect, useMemo, useState } from "react"
import _ from "underscore";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { Dropdown } from "primereact/dropdown";
import { ToastContext } from "../../../../context/ToastContext";

export const useCreateNode = ({ editNode, onClose, nodeOptions }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [options, setOptions] = useState({ pairs: [] });
    const [filterValues, setFilterValues] = useState({showSelected: false, showActive: true});
    const [formValues, setFormValues] = useState({ selectedUsers: [], relations: {}, activePairs: [] });
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const fields = [
        {
            label: "Node Name",
            name: "node_name",
            col: "12",
            type: "text",
            required: true,
        },
        {
            label: "Description",
            name: "node_description",
            col: "12",
            type: "textarea",
            required: false,
        },
    ]
    const columns = [
        {
            label: "",
            key: "",
            checkbox: true,
            style: { width: "5%" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                const checked = row?.id === "all" ? (_.isEmpty(rowData) ? false : _.every(rowData, item => formValues?.selectedUsers?.includes(item?.user_code))) : formValues?.selectedUsers?.includes(row?.user_code);
                return (
                    <div className="d-flex justify-content-center">
                        <input type="checkbox" className="c-pointer" checked={checked} onChange={(e) => { setFormValues((prev) => ({ ...prev, selectedUsers: row?.id === "all" ? [...(e.target?.checked ? _.pluck(rowData, "user_code") : [])] : (e?.target?.checked ? [...prev?.selectedUsers, row?.user_code] : prev?.selectedUsers?.filter(user => user !== row?.user_code)) })) }} />
                    </div>
                );
            },
        },
        {
            label: "Member",
            key: "user_display_name",
            style: { width: "35%" },
            render: (row) => <div className="text-truncate fw-semibold" title={`${row?.user_display_name} ( ${row?.employee_id} )`} style={{ lineHeight: "17px" }}>
                {row?.user_display_name} <span style={{ fontSize: "11px", color: "#9d9999" }}>{row?.employee_id}</span>
            </div>
        },
        {
            label: "Relation",
            key: "relation",
            style: { width: "21%" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return <div>
                    <Dropdown options={nodeOptions?.relations || []} optionLabel="relation_name" filter filterInputAutoFocus value={formValues?.relations?.[row?.user_code] || formValues?.defaultRelations?.[row?.user_code] || null} onChange={(e) => setFormValues((prev) => ({ ...prev, relations: { ...prev?.relations, [row?.user_code]: e?.target?.value } }))} disabled={!formValues?.selectedUsers?.includes(row?.user_code)} />
                </div>
            }
        },
        {
            label: "Tenure (1Yr+)",
            key: "tenure_1_plus_yr",
            style: { width: "13%" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const isYes = row?.tenure_1_plus_yr?.toLowerCase()?.includes("yes");
                return <div className="d-flex justify-content-center" style={{ fontSize: "12px" }}>
                    <div className="px-2 fw-semibold text-truncate" style={{ width: "fit-content", backgroundColor: isYes ? "#ecfdf5" : "#fff1f2", border: `1px solid ${isYes ? "#a7f3d080" : "#fecdd380"}`, color: isYes ? "#047857" : "#e11d48" }}>{row?.tenure_1_plus_yr}</div>
                </div>
            }
        },
        {
            label: "Project (30D+)",
            key: "project_30_plus_days",
            style: { width: "13%" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const isYes = row?.project_30_plus_days?.toLowerCase()?.includes("yes");
                return <div className="d-flex justify-content-center" style={{ fontSize: "12px" }}>
                    <div className="px-2 fw-semibold text-truncate" style={{ width: "fit-content", backgroundColor: isYes ? "#ecfdf5" : "#fff1f2", border: `1px solid ${isYes ? "#a7f3d080" : "#fecdd380"}`, color: isYes ? "#047857" : "#e11d48" }}>{row?.project_30_plus_days}</div>
                </div>
            }
        },
        {
            label: "Timesheet (70%+)",
            key: "timesheet_70_plus_percent",
            style: { width: "13%" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const isYes = row?.timesheet_70_plus_percent?.toLowerCase()?.includes("yes");
                return <div className="d-flex justify-content-center" style={{ fontSize: "12px" }}>
                    <div className="px-2 fw-semibold text-truncate" style={{ width: "fit-content", backgroundColor: isYes ? "#ecfdf5" : "#fff1f2", border: `1px solid ${isYes ? "#a7f3d080" : "#fecdd380"}`, color: isYes ? "#047857" : "#e11d48" }}>{row?.timesheet_70_plus_percent}</div>
                </div>
            }
        },
    ]

    useEffect(() => {
        filterValues?.apiCall && getUserList();
    }, [filterValues?.apiCall])

    useEffect(() => {
        if (!_.isEmpty(editNode)) {
            const nodeMembers = _.pluck(editNode?.members, "node_member_user_code");
            let relations = {};
            nodeMembers?.forEach(user => {
                relations[user] = _.findWhere(nodeOptions?.relations, { relation_id: _.find(editNode?.members, item => item?.node_member_user_code === user)?.relation_id })
            })
            setFormValues((prev) => ({ ...prev, ...editNode, selectedUsers: nodeMembers?.map(item => item), relations }));
        }
    }, [editNode, nodeOptions?.relations])

    useEffect(() => {
        if (!_.isEmpty(formValues?.selectedUsers)) {
            const relations = formValues?.selectedUsers?.map((user, index) => { return { idx: index, ...(formValues?.relations?.[user] || formValues?.defaultRelations?.[user]) } });
            let pairs = [];
            relations?.forEach(rel => {
                let obj = {
                    from_relation_id: rel?.relation_id,
                    from_relation_name: rel?.relation_name
                }
                _.filter(relations, item => item?.idx !== rel?.idx)?.forEach(item => {
                    obj["to_relation_id"] = item?.relation_id;
                    obj["to_relation_name"] = item?.relation_name
                    pairs.push({ ...obj });
                })
            })
            let uniqPairs = _.sortBy(_.uniq(pairs, item => `${item?.from_relation_id}-${item?.to_relation_id}`), "from_relation_name");

            // select pair when editing
            let selectedPairs = [];
            if (!_.isEmpty(editNode)) {
                editNode?.eligible_pairs?.forEach(pair => {
                    const findPair = _.findWhere(uniqPairs, { from_relation_id: pair?.from_relation_id, to_relation_id: pair?.to_relation_id });
                    if (findPair) selectedPairs.push(findPair);
                })
            } else {
                selectedPairs = [...(uniqPairs || [])];
            }
            setOptions((prev) => ({ ...prev, pairs: uniqPairs }));
            setFormValues((prev) => ({ ...prev, activePairs: selectedPairs }));
        } else {
            setOptions((prev) => ({ ...prev, pairs: [] }));
            setFormValues((prev) => ({ ...prev, activePairs: [] }));
        }
    }, [formValues?.relations, formValues?.selectedUsers])

    const getUserList = async () => {
        try {
            setLoader((prev) => ({ ...prev, grid: true }));
            const payload = {
                project_ids: _.pluck(filterValues?.projects, "project_id")?.toString() || "",
                project_lead_user_codes: _.pluck(filterValues?.project_leads, "user_code")?.toString() || "",
                user_status_id: _.pluck(filterValues?.user_status, "user_status_id")?.toString() || "",
                company_experience: 0,
                project_duration: 0,
                is_active_members: filterValues?.showActive
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYEVALUATETEAMLIST"), payload);
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.user_list?.sort((a, b) => a?.user_display_name?.localeCompare(b?.user_display_name));
                setRowData(data);

                // set default relation for all as peer
                let defaultRelations = {};
                data?.forEach(user => {
                    defaultRelations[user?.user_code] = _.find(nodeOptions?.relations, rel => rel?.relation_name?.toLowerCase() === "peer");
                })
                setFormValues((prev) => ({ ...prev, defaultRelations }));
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, grid: false }));
            setFilterValues((prev) => ({ ...prev, apiCall: false }));
        }
    }

    const upsertNode = async (outerFormValue) => {
        try {
            if (!formValues?.node_name && !outerFormValue) {
                showInfo("Info", "Please enter the node name");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            const payloadValues = outerFormValue || formValues
            const tvpNode = payloadValues?.selectedUsers?.map(user => ({ user_code: user, relation_id: payloadValues?.relations?.[user]?.relation_id || payloadValues?.defaultRelations?.[user]?.relation_id || 0 }));
            const tvpRelation = payloadValues?.activePairs?.map(rel => ({ from_relation_id: rel?.from_relation_id, to_relation_id: rel?.to_relation_id }))
            const payload = {
                node_id: payloadValues?.node_id || 0,
                node_name: payloadValues?.node_name || "",
                node_description: payloadValues?.node_description || "",
                is_active: true,
                is_verified: true,
                tvp_survey_nodes_members: tvpNode || [],
                tvp_survey_eligible_relations: tvpRelation || []
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSURVEYNODEDETAILS"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                onClose();
                onReset();
            } else {
                showError("Error: ", res?.body?.message);
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error: ", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const onReset = () => {
        setFormValues((prev) => ({ ...prev, selectedUsers: [], relations: {}, activePairs: [] }));
    }

    const filteredRowData = useMemo(() => {
        const filteredData = filterValues?.showSelected ? rowData?.filter(row => formValues?.selectedUsers?.includes(row?.user_code)) : rowData;
        if (!filterValues?.search) return filteredData;
        return filteredData?.filter(data => data?.user_display_name?.toLowerCase()?.includes(filterValues?.search?.toLowerCase()));
    }, [filterValues?.search, rowData, filterValues?.showSelected])

    return { fields, formValues, setFormValues, filterValues, setFilterValues, columns, rowData: filteredRowData, loader, upsertNode, onReset, options }
}